/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';

/**
 * redirected to this component when data is not found
 * 
 * @returns html to render not found page
**/

export class NoData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalType: props.type
        }
    }

    closeModal = (type) => {
        this.setState({
            modalType: ''
        })
        if (type == 'expiry') {
            window.location.reload();
            this.props.history.goBack();
        } else if (type == 'logout') {
            if (this.props?.history?.length > 1) {
                this.props.history.goBack();
            } else {
                this.props.history.push('/');
            }
        }  
    }

    render () {
        return (
            this.props.type == "noData" || this.props.type == "apiError" ? 
                <Modal show={this.state.modalType} centered size="sm" animation={false} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center text-center align-items-center">
                            Action could not be completed. Please refresh and try again. Email CTBids Help if the problem persists.  
                            <div className="d-flex flex-row mt-4">
                                <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => {this.closeModal('logout')}}>Close</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            : this.props.type == "expiryError" ?  
                <Modal show={this.state.modalType && !this.props.sessionModal} centered size="sm" animation={false} keyboard={false}>
                    <Modal.Body>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            Your session has expired. Please refresh the screen or logout and log back in. 
                            <div className="d-flex flex-row mt-4">
                                <Button variant="secondary mx-2" style={{ width: '120px' }} onClick={() => {this.closeModal('expiry')}}>Close</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal> : ''
        );
    }
}